module.exports = __webpack_public_path__ + "fonts/Graphik-RegularItalic-Web.6b4661c.woff";